import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface MobileQuickRegisterBarProps {
  onQuickRegister: () => void;
  routeCommunityId?: string;
  label?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

export function MobileQuickRegisterBar({
  onQuickRegister,
  routeCommunityId,
  label = 'Register Now',
  isLoading = false,
  disabled = false,
}: MobileQuickRegisterBarProps) {
  return (
    <div
      className={`fixed left-0 right-0 p-4 bg-background border-t z-50 md:hidden shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] ${
        routeCommunityId ? 'bottom-20 pb-4' : 'bottom-0 pb-safe'
      }`}
    >
      <Button
        onClick={onQuickRegister}
        disabled={disabled || isLoading}
        className="w-full text-base font-semibold py-6"
        size="lg"
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            Registering...
          </>
        ) : (
          label
        )}
      </Button>
    </div>
  );
}
